(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("WebIMConfig"));
	else if(typeof define === 'function' && define.amd)
		define(["WebIMConfig"], factory);
	else if(typeof exports === 'object')
		exports["WebIMConfig"] = factory(require("WebIMConfig"));
	else
		root["WebIMConfig"] = factory(root["WebIMConfig"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__121__) {
return 